export default {
    liked: 'liked',
    disliked: 'disliked',
    shown: 'shown',
}